import { BackwardsCompatibleLocationInformationFragment, EntityLayerFragment } from 'types/graphql'

import { routes } from '@cedarjs/router'

import { formatListSentence, ListEnding, toTitleCase } from 'src/utils'

export const backwardsCompatibleAddressUrl = (
  backwardsCompatibleLocationInformation: BackwardsCompatibleLocationInformationFragment
) => {
  const { address, addressEntityUuid, parcelEntityUuid } = backwardsCompatibleLocationInformation

  if (addressEntityUuid) {
    return routes.entityAddress({ addressUuid: addressEntityUuid })
  }
  if (parcelEntityUuid) {
    return routes.entityParcel({ parcelUuid: parcelEntityUuid })
  }

  return routes.staffAddressOverview({ addressDisplayName: encodeURIComponent(address?.str ?? '') })
}

export const backwardsCompatibleParcelUrl = (
  backwardsCompatibleLocationInformation: BackwardsCompatibleLocationInformationFragment
) => {
  const { parcelDisplayName, parcelEntityUuid } = backwardsCompatibleLocationInformation

  if (parcelEntityUuid) {
    return routes.entityParcel({ parcelUuid: parcelEntityUuid })
  }

  return routes.staffParcelOverview({
    parcelDisplayName: encodeURIComponent(parcelDisplayName ?? ''),
  })
}

export const getSearchEntityLayersCaption = (entityLayers: EntityLayerFragment[]) => {
  if (!entityLayers.length) {
    return ''
  }
  return `Search for ${formatListSentence({
    words: entityLayers.map((el) => toTitleCase(el.name)),
    hideFinalPeriod: true,
    finalItemDelimiter: ListEnding.OR,
  })}`
}
